export default __webpack_public_path__ + "static/media/P-005.fe726e29.png";